import React, { useState } from "react";
import './App.css';
import Navbar from './components/Navbar';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import SignUp from './components/SignUp';
import SignIn from './components/SignIn';
import Profile from './screens/Profile';
import ProfileOptions from './screens/ProfileOptions';
import Creator from './screens/Creator';
import UserProfile from './components/UserProfile';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { LoginContext } from './context/LoginContext';
import Modal from './components/Modal';
import { GoogleOAuthProvider } from '@react-oauth/google';

function App() {
  const [userLogin, setUserLogin] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <BrowserRouter>
      <div className="App">
        <GoogleOAuthProvider clientId="288414574089-ub66qjbq2tmag4gp021pm33ltfs93vii.apps.googleusercontent.com">
          <LoginContext.Provider value={{ setUserLogin, setModalOpen }}>
            <Navbar login={userLogin} />
            <Routes>
              <Route path='/' element={<Profile />} />
              <Route path='/profile' element={<Profile />} />
              <Route path='/profile/:userid' element={<UserProfile />} />
              <Route path='/profile/options' element={<ProfileOptions />} />
              <Route path='/profile/creator' element={<Creator />} />
              <Route path='/signup' element={<SignUp />} />
              <Route path='/signin' element={<SignIn />} />
              <Route path='*' element={<Navigate to="/profile" replace />} />
            </Routes>
            <ToastContainer theme="dark" />
            {modalOpen && <Modal setModalOpen={setModalOpen} />}
          </LoginContext.Provider>
        </GoogleOAuthProvider>
      </div>
    </BrowserRouter>
  );
}

export default App;
